"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextButton = exports.Container = exports.ModalHeader = void 0;

var _stylitas = require("@creditas/stylitas");

var _button = require("@creditas-lab/button");

var _modal = require("@creditas-lab/modal");

var _styledTools = require("styled-tools");

var ModalHeaderStyled = (0, _stylitas.styled)(_modal.ModalHeader)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n"])));
exports.ModalHeader = ModalHeaderStyled;

var Container = _stylitas.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n"])));

exports.Container = Container;
Container.Header = _stylitas.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
Container.Body = _stylitas.styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
Container.Footer = _stylitas.styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n"])));
var NextButton = (0, _stylitas.styled)(_button.Button)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background: ", ";\n  width: 60px;\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 16px;\n"])), (0, _styledTools.theme)('colorNeutral90'));
exports.NextButton = NextButton;